import { StyleSheet } from "react-native";
import { height, width } from "../../utils/utils";
export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewListDetail: {
    paddingHorizontal: width * 0.04,
    paddingVertical: width * 0.03,
  },
});
export const stylesResponsive = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  viewListDetail: {
    paddingHorizontal: width * 0.04,
    paddingVertical: width * 0.03,
  },
});
